/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ text: NonNullable<unknown> }} Einvoice_Stuck_Report_AfterInputs */

const vi_einvoice_stuck_report_after = /** @type {(inputs: Einvoice_Stuck_Report_AfterInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.text} Báo quản trị.`)
};

/**

* @param {Einvoice_Stuck_Report_AfterInputs} inputs
* @param {{ locale?: "vi" }} options
* @returns {LocalizedString}
*/
export const einvoice_stuck_report_after = /** @type {((inputs: Einvoice_Stuck_Report_AfterInputs, options?: { locale?: "vi" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Einvoice_Stuck_Report_AfterInputs, { locale?: "vi" }, {}>} */ ((inputs, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return vi_einvoice_stuck_report_after(inputs)
});